import React from 'react';
import { SvgIconProps, Tooltip } from '@mui/material';
import MessageIcon from '@mui/icons-material/Message';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';

import type { CustomStepType, StatusActivityStatus } from '@shared/patient-intake-status';

import { getStepConfig } from '../getStepConfig';

const throwNeverStatus = (status: never) => {
  throw new Error(`Status does not exist: ${status}`);
};

interface IconWrapperProps extends React.ComponentProps<typeof Tooltip> {
  children: React.ReactElement<SvgIconProps>;
}

const IconWrapper = ({ title, children, ...props }: IconWrapperProps) => (
  <Tooltip title={title} placement="top" {...props}>
    {children}
  </Tooltip>
);

interface CustomStepIconProps extends SvgIconProps {
  customStepType: CustomStepType;
  status: StatusActivityStatus | undefined;
}

export const CustomStepIcon = ({ customStepType, status, ...iconProps }: CustomStepIconProps) => {
  const stepConfig = getStepConfig(customStepType);
  const { label } = stepConfig.statuses[status ?? 'NOT_STARTED'];

  switch (customStepType) {
    case 'DOCUMENT_UPLOAD':
      return (
        <IconWrapper title={label}>
          <UploadFileOutlinedIcon {...iconProps} />
        </IconWrapper>
      );
    case 'MESSAGE':
      return (
        <IconWrapper title={label}>
          <MessageIcon {...iconProps} />
        </IconWrapper>
      );
    case 'DISCHARGE_LETTER_UPLOAD':
      return (
        <IconWrapper title={label}>
          <ArticleOutlinedIcon {...iconProps} />
        </IconWrapper>
      );
    default:
      return throwNeverStatus(customStepType);
  }
};
